<template>
  <div class="h-full w-full flex flex-col">
    <OnboardingHeader class="z-[10]" />

    <div class="relative h-full w-full overflow-hidden">
      <div class="pb-8 px-4 sm:px-8">
        <SectionsList :list="filteredSections" />
      </div>

      <!-- <img
        src="/images/big-interface-paywall.png"
        class="absolute inset-0 w-full h-full object-cover hidden lg:block"
        alt="Capino interface desktop"
      />

      <img
        src="/images/medium-interface-paywall.png"
        class="absolute inset-0 w-full h-full object-cover hidden md:block lg:hidden"
        alt="Capino interface tablet"
      />

      <img
        src="/images/small-interface-paywall.png"
        class="absolute inset-0 w-full h-full object-cover block md:hidden"
        alt="Capino interface mobile"
      /> -->

      <HubPaywallLocked />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import OnboardingHeader from '@/components/Onboarding/OnboardingHeader.vue'

import SectionsList from '@/components/Hub/Sections/SectionsList.vue'
import HubPaywallLocked from '@/components/Hub/HubPaywallLocked.vue'

export default {
  name: 'HubPaywall',

  components: {
    OnboardingHeader,
    SectionsList,
    HubPaywallLocked
  },

  computed: {
    ...mapState('sections', ['sections']),

    filteredSections() {
      let list = this.sections.list.filter(
        section => !['tutorial', 'playground'].includes(section.slug)
      )

      return list
    }
  }
}
</script>
